import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useCallback, useMemo } from 'react';
import { useForm } from 'react-hook-form';

import AutoComplete from 'components/field/AutoComplete';
import Button from 'components/field/Button';
import StringInput from 'components/field/StringInput';
import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import Alert from 'components/global/Alert';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { AUTOCOMPLETE, EMAIL } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const SendTestEmailModal = NiceModal.create(({ id }) => {
	const schema = useMemo(
		() =>
			yup
				.object()
				.shape({
					orderID: yup.string().nullable().required(),
					email: yup.string().email().nullable().required()
				})
				.required(),
		[]
	);

	const axiosPrivate = useAxiosPrivate();
	const { showError, showSuccess } = useAlert();
	const modal = useModal();

	const handleCloseModal = useCallback(() => {
		modal.remove();
	}, []);

	const formMethods = useForm({
		resolver: yupResolver(schema)
	});

	const {
		setValue,
		watch,
		handleSubmit,

		formState: { isSubmitting }
	} = formMethods;

	const onSubmit = useCallback(
		async (data) => {
			await axiosPrivate
				.post(EMAIL.TEST_EMAIL_SETTING, {
					emailSettingID: id,
					...data
				})
				.then((response) => {
					const { status } = response;

					if (status !== 200) {
						showError();
						return;
					}

					showSuccess();
					handleCloseModal();
				})
				.catch((error) => {
					AppLogger.error(error);
					showError();
				});
		},
		[id]
	);

	const defaultColSpan = {
		md: 6
	};

	const orderIdAutocompleteColumns = useMemo(() => [{ accessor: 'orderID', width: 200 }], []);
	const orderIdAutocompleteLabels = useMemo(() => ['orderID'], []);

	return (
		<Modal>
			<ModalTitle>
				<Typography variant="p1">sendTestEmail</Typography>
			</ModalTitle>
			<ModalContent>
				<Form formMethods={formMethods}>
					<FormItem>
						<Alert content="sendTestEmailModal.description" showIcon />
					</FormItem>
					<FormItem label="orderNo" colSpan={defaultColSpan}>
						<AutoComplete
							autoCompleteName={AUTOCOMPLETE.ORDERS}
							columns={orderIdAutocompleteColumns}
							selectionLabelAccessor={orderIdAutocompleteLabels}
							value={watch('orderID')}
							setValue={(value) => {
								setValue('orderID', value?.ID ?? null);
							}}
						/>
					</FormItem>
					<FormItem label="email" colSpan={defaultColSpan}>
						<StringInput name="email" />
					</FormItem>
				</Form>
			</ModalContent>
			<ModalActions>
				<Button label="cancel" variant="outline" onClick={handleCloseModal} />
				<Button
					label="sendTestEmail"
					loading={isSubmitting}
					onClick={handleSubmit(onSubmit, (errors) => {
						AppLogger.log(errors);
					})}
				/>
			</ModalActions>
		</Modal>
	);
});

export default SendTestEmailModal;
